import { X } from 'lucide-react';

export default function HelpMenu({ title, content, onClose, buttonText = 'Get Started' }) {
  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center" style={{ paddingBottom: '80px' }}>
      <div className="absolute inset-0 bg-foreground/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-[90%] max-w-md flex flex-col rounded-3xl bg-card border border-primary shadow-xl overflow-hidden" style={{ maxHeight: 'calc(90vh - 72px)' }}>
        <button onClick={onClose} className="absolute right-4 top-4 z-10 text-muted-foreground">
          <X className="h-5 w-5" />
        </button>
        <div className="bg-gradient-to-br from-primary to-accent p-6 text-primary-foreground shrink-0">
          <h2 className="text-2xl font-bold">{title}</h2>
        </div>
        <div className="p-4 overflow-y-auto flex-1">
          {content}
        </div>
        <div className="p-4 pt-0 shrink-0">
          <button
            onClick={onClose}
            className="w-full rounded-full bg-primary py-3 text-sm font-semibold text-primary-foreground shadow"
            style={{ marginTop: '5px' }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}
